import api from './index.js'

export default {

  getEvents() {
    return api.get('events.json');
  },

  getEvent(id) {
    return api.get(`events/${id}.json`);
  },

  createEvent(params) {
    return api.post('events.json', params);
  },

   deleteEvent(id) {
    return api.delete(`events/${id}.json`);
  },

  updateEvent(payload) {
    return api.patch(`events/${payload.eventId}.json`, payload.params);
  }
}
